export default __webpack_public_path__ + "static/media/bars.4aed988d.svg";